import { app } from '../../../app';

app.factory('ContactService', ContactService);

/** @ngInject */
function ContactService($resource) {
    return $resource('app/rest/contact', {}, {});
}



// WEBPACK FOOTER //
// ./src/portal/states/public/contact/contact.service.js